import React, { useEffect, useState, useMemo } from 'react';
import useSubscriptionPurchase from '../../hooks/useSubscriptionPurchase';
import { errorToast, successToast } from '../../helpers/toastHelper';
import { handleErrorMessageFromAPIFailer } from '../../helpers/axiosHelper';
import {
  apiGetCreditDetails,
  deductImagineCreditProductCount,
  setAllProductsUsedCount,
  setClientSubscriptionPlans,
  setMainSubscriptionPlans,
} from '../../api/subscription/subscription';
import { useUserContext } from '../../contexts/UserContext';
// import Switch from '../../components/admin/switch';
import MinusIcon from '../../components/icons/MinusIcon';
import { PlusIcon } from '../../assets/icons';
import Button from '../../components/Button';
import { ModalArea } from '../../common/ModalButtonArea';
import styles from './DeductImagineCredit.module.scss';
import {
  // Checkbox,
  Loader,
} from '../../common';
import { openFormInCaseOfNewOrgAndFreemiumUser } from '../../helpers/jsHelper';
import { IMAGINE_CREDIT_BASE_TYPE } from '../../constants/constants';
import { useDispatch } from 'react-redux';
import { subscriptionActions } from '../../redux/slicers/subscriptionSlicer';
export default function DeductImagineCredit() {
  const { imagineCreditLimit:AllCredit, getImagineCreditInfo } = useSubscriptionPurchase({
    imagineCredit: true,
  });
  const dispatch = useDispatch()
  const { currentUser } = useUserContext();
  const currentOrg = currentUser?.organization;
  const [formData, setFormData] = useState([]);
  const [loading, setLoading] = useState('get');
  const [saving, setSaving] = useState(false);
  const [show, setShow] = useState(false);
  const totalCredits = formData.reduce((acc, curr) => {
    return acc + Number(curr?.value || 0) * Number(curr?.cost || 0);
  }, 0);

  const imagineCreditLimit = useMemo(() => {
  return AllCredit?.find(({ basemodeltype }) =>
    basemodeltype?.toLowerCase().trim() === IMAGINE_CREDIT_BASE_TYPE?.toLowerCase().trim()
  );
}, [AllCredit]);

  useEffect(() => {
    if (show) {
      fetchData();
    } else {
      setFormData([]);
    }
  }, [show]);

  const fetchData = async () => {
    try {
      setLoading('get');
      const response = await apiGetCreditDetails();
      setFormData(response?.results || []);
    } catch {
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e, index) => {
    const { name, value } = e.target;
    const clone = [...formData];
    clone[index][name] = +value || 1;
    setFormData(clone);
  };

  const handleChangeCta = (index, type) => {
    const clone = [...formData];
    const val = +clone[index]['value'] || 0;
    if (!type && val < 1) return;
    clone[index]['value'] = type ? val + 1 : val - 1;
    if (clone[index]['value'] < 1) {
      clone[index]['value'] = 0;
    }
    clone[index]['value'] = +clone[index]['value']?.toFixed(1) * 1;
    setFormData(clone);
  };

  // const handleCheckboxChange = (index) => {
  //   const clone = [...formData];
  //   clone[index]['selected'] = !clone[index]['selected'];
  //   setFormData(clone);
  // };

  const handleSubmit = async () => {
    if (!totalCredits) return;
    const availableLimit = Number(imagineCreditLimit?.available_limit || 0);
    let description = `A new request has been submitted by ${currentUser?.user?.name || ''} from ${
      currentUser?.organization_detail?.name || ''
    }.\nRequest details:\n`;
    let cost = 0;
    const creditData = [];
    const filteredData = formData.filter((val) => val?.value);
    filteredData.map((ins, index) => {
      cost += Number(ins?.value || 0) * Number(ins?.cost || 0);
      description += `${index + 1}. ${ins?.label_name} - ${ins.value} Quantity.\n`;
      creditData.push({
        id: ins?.id,
        quantity: ins.value
      });
    });
    if (!availableLimit || cost > availableLimit) {
      const message = !availableLimit
        ? 'You have 0 credits remaining'
        : 'Insufficient credits for this action';
      errorToast(
        `${message}. Please fill out our quick Enterprise Request Form, and our team will reach out to you soon.`
      );
      openFormInCaseOfNewOrgAndFreemiumUser();
      return;
    }
    try {
      setSaving(true);
      const fd = new FormData();
      fd.append('organization_id', currentOrg);
      fd.append('credit_cost', cost);
      fd.append('description', description);
      fd.append("credit_data", JSON.stringify(creditData));
      const res = await deductImagineCreditProductCount(fd);
      if (res?.status === 200 || res?.status === 201 || res?.status || res?.data?.status) {
        getImagineCreditInfo?.();
        dispatch(setAllProductsUsedCount())
        dispatch(subscriptionActions.setPlanDetailsLoading(true));
        dispatch(setClientSubscriptionPlans());
        dispatch(setMainSubscriptionPlans());  
        successToast(res?.message || 'Successfully deducted imagine credits');
        setShow(false);
      } else handleErrorMessageFromAPIFailer(res);
    } catch {
      errorToast('Something went wrong. Please try again.');
    } finally {
      setSaving(false);
    }
  };

  const handleOpenDialog = () => setShow(!show);

  if (!imagineCreditLimit) return null;

  return (
    <div>
      <span className={styles['label-title']} onClick={handleOpenDialog}>
        Content Request
      </span>
      <ModalArea
        showModal={show}
        setShowModal={handleOpenDialog}
        title="Content Request"
        size="xl"
        centered
        headingLeft
        body={
          <div className="w-100 h-100 d-flex pt-2" style={{ minHeight: '360px' }}>
            {loading && <Loader loading size={32} thickness={4} />}
            <div
              className={`${styles.innerSection} ${styles.sectionPartition}  pe-3 ${
                loading ? 'd-none' : 'd-block'
              }`}>
              <div className={`${styles['credit-form']} p-0`}>
                {formData.map((field, index) => {
                  return (
                    <div className={styles['form-group']} key={index}>
                      <div className={`d-flex gap-2 ${styles['container-box']}`}>
                        <div
                          className="d-flex flex-column justify-content-start align-items-start"
                          style={{ gap: '0px', maxWidth: 'calc(100% - 125px)' }}>
                          {/* <span className={styles['switch-width']}>
                        <Checkbox
                          selected={field.selected}
                          onChange={() => handleCheckboxChange(index)}
                          style={{ cursor: 'pointer' }}
                        />
                      </span> */}
                          <div
                            className={`ellipsis w-100 ${styles.fontBold}`}
                            title={field?.label_name}>
                            {field?.label_name}
                          </div>
                          <div className={`${styles.noText} ${styles.creditsText} w-100`}>
                            {field?.info}
                          </div>
                        </div>
                        <div>
                          {/* {field.selected && ( */}
                          <Button
                            size="xlg"
                            className={`${styles['qty-btn']} selection-button black-btn cursor-pointer add-to-cart-btn`}>
                            <MinusIcon
                              className="me-1"
                              onClick={() => handleChangeCta(index, false)}
                            />
                            <input
                              type="number"
                              onChange={(e) => handleChange(e, index)}
                              value={field.value ?? 0}
                              name="value"
                              id={index}
                            />
                            <PlusIcon
                              className="ms-1"
                              onClick={() => handleChangeCta(index, true)}
                            />
                          </Button>
                          {/* )} */}
                        </div>
                      </div>
                    </div>
                  );
                })}
                {!formData?.length && !loading && (
                  <>
                    <div className={styles['noData']}>No data available</div>
                  </>
                )}
              </div>
            </div>
            <div
              className={`${
                styles.innerSection
              } ps-3 d-flex flex-column justify-content-between align-items-start ${
                loading ? 'd-none' : 'd-block'
              }`}>
              <div className="w-100 h-auto">
                <h5 className="mb-0">Your Request Summary</h5>
                {!totalCredits && (
                  <div className={`my-3 ${styles.noText}`}>Please add request to proceed</div>
                )}
                {!!totalCredits &&
                  formData.map((ins, index) => {
                    const credits = Number(ins?.value || 0) * Number(ins?.cost || 0);
                    return (
                      <div
                        className={`w-100 py-2 ${styles.addedRequestItem} ${
                          ins?.value ? 'd-block' : 'd-none'
                        } d-flex justify-content-between align-items-center`}
                        key={index}>
                        <div className={`d-flex ${styles.label}`}>
                          <span className="ellipsis" title={ins?.label_name}>
                            {ins?.label_name}
                          </span>
                          <span className={`${styles.label}`}>&nbsp;x&nbsp;{ins?.value}</span>
                        </div>
                        <span className={styles.noText}>
                          {credits} credit
                          {credits > 1 ? 's' : ''}
                        </span>
                      </div>
                    );
                  })}
              </div>
              <Button
                size="lg"
                onClick={handleSubmit}
                loading={saving}
                disabled={!totalCredits || saving}
                fullWidth>
                Submit Request
              </Button>
            </div>
          </div>
        }
      />
    </div>
  );
}
